import React from "react";

export default function DashboardChartTooltip({ active, payload, label }) {
  if (!active || !Array.isArray(payload) || payload.length === 0) return null;
  const fullLabel = payload[0]?.payload?.display_label || label;
  return (
    <div className="max-w-[280px] rounded-md border border-border bg-popover px-3 py-2 text-xs text-popover-foreground shadow-brutal">
      {fullLabel ? <p className="mb-1 break-words font-semibold">{fullLabel}</p> : null}
      <div className="space-y-1">
        {payload.map((entry) => (
          <div key={`${entry.dataKey}-${entry.name}`} className="flex items-center justify-between gap-4">
            <span className="flex min-w-0 items-center gap-1.5 break-words">
              <span
                className="h-2 w-2 shrink-0 rounded-sm"
                style={{ backgroundColor: entry.color || entry.fill }}
                aria-hidden="true"
              />
              {entry.name}
            </span>
            <span className="shrink-0 font-semibold tabular-nums">{entry.value ?? 0}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
